import * as React from "react";
import {cs} from "../../../../../../react/chain-services";
import "./delete-action-in-table.scss";
import {UseState} from "../../../../../../react/use-state";
import {cx} from "emotion";

export const DeleteActionInTable = ({onDelete, xdQaName=undefined}) => cs(
    ["deleting", (_, next) => UseState({next})],
    ({deleting}) => (
        <a
            className={cx("delete-action-in-table-67j", {
                disabled: deleting.value,
            })}
            onClick={async () => {
                if (deleting.value) {
                    return;
                }
                deleting.onChange(true);
                await onDelete();
                deleting.onChange(false);
            }}
            xd-qa-type="icon"
            xd-qa-name={xdQaName+" Delete"}
        >
            {deleting.value ? (
                <i className="fa fa-spinner fa-pulse" xd-qa-type="icon" xd-qa-name={xdQaName+" Processing icon"}/>
            ) : (
                <span className="delete fa fa-close"></span>
            )}
        </a>
    )
);
